import React from 'react';
import PropTypes from 'prop-types';

const PackBadge = ({ count }) => {
    if (!count || count <= 0) return null;
    return <span className="pack-badge">({count > 99 ? '99+' : count})</span>;
};

PackBadge.propTypes = {
    count: PropTypes.number,
};

export default PackBadge;
